<template>
    <div>
        <div class="absolute top-0 left-0 right-0 mx-auto">
            <div class="mt-12 mb-8 text-sm text-indigo-200">
                {{ $t('Completed') }}
                <span class="font-semibold">{{ unanswered_question_count }}</span>
                {{ $t('of')}}
                <span class="font-semibold">{{ total_question_count }}</span>
                {{ $t('questions') }}
            </div>
        </div>

        <div class="defaultstyles wizard-questions">
            <div class="question-blocks text-white">
                <div aria-live="polite">
                    <transition v-if="current_question"
                        name="question"
                    >
                        <component
                            class="absolute flex items-center w-full h-full inset-0"
                            :is="component"
                            :key="current_question.id"
                            :question="current_question"
                            :saving="saving"
                            aria-live="polite"
                            @answered="answered"
                        />
                    </transition>

                    <div v-else class="text-center">
                        <button class="submitResults px-5 py-3"
                            aria-label="Activity complete, click to start next activity"
                            :class="{ 'loading': loading }"
                            @click="nextActivity"
                        >
                            {{ $t('Next') }}
                            <i aria-hidden="true" class="material-icons align-middle text-3xl">forward</i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        demo: false,
        route: '',
        wizard_blocks: { default() {[]} },
    },

    data() {
        return {
            loading: false,
            saving: false,
            questions: this.wizard_blocks,
        }
    },

    computed: {
        component() {
            return this.current_question.attributes.question_format;
        },
        current_question() {
            return this.questions.find(item => ! item.answered);
        },
        total_question_count() {
            return this.questions.length;
        },
        unanswered_question_count() {
            return this.questions.filter(item => item.answered).length;
        },
    },

    methods: {
        answered(value) {
            if (this.demo) {
                return this.answerDemoQuestion();
            }

            if (this.saving) {
                return;
            }

            this.saving = true;

            axios.put(this.route + this.current_question.id, {
                results: value,
            })
            .then(() => {
                setTimeout(() => {
                    this.saving = false;
                    this.current_question.answered = true;
                }, 200);
            })
            .catch(error => {
                this.saving = false;
                console.log(error.response)
            });
        },
        answerDemoQuestion() {
            setTimeout(() => {
                this.current_question.answered = true;
            }, 200);
        },
        nextActivity() {
            this.loading = true;
            location.reload();
        },
    }
};
</script>

<style>
.question-enter-active, .question-leave-active {
    transition: transform .3s ease, opacity .3s ease;
    transform: translateY(0);
    opacity: 1;
}

.question-enter {
    opacity: 0;
    transform: translateY(-50%);
}

.question-leave-to {
    opacity: 0;
    transform: translateY(50%);
}
</style>
